import { render, staticRenderFns } from "./CardBo.vue?vue&type=template&id=469ecf9a&"
import script from "./CardBo.vue?vue&type=script&lang=js&"
export * from "./CardBo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports